// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { VisuallyHidden } from 'common/styles/oc-styled-components';

import RatingHalfStarSvg from '../svgs/RatingHalfStarSvg';
import RatingStarSvg from '../svgs/RatingStarSvg';

import { InlineFlex } from './styled-components';

// Component
const RatingStars = ({ averageRating, sideLength, starColor }) => (
  <div>
    <VisuallyHidden>{`${averageRating} out of 5 stars`}</VisuallyHidden>
    <InlineFlex aria-hidden>
      {[1, 2, 3, 4, 5].map((val) => {
        if (Math.round((averageRating - val) * 10) / 10 === -0.5) {
          return (
            <RatingHalfStarSvg
              height={sideLength}
              key={val}
              width={sideLength}
            />
          );
        }
        const fillColor = starColor || '#507C75';
        const color = averageRating - val < -0.5 ? '#E7E6E7' : fillColor;
        return (
          <RatingStarSvg
            color={color}
            height={sideLength}
            key={val}
            width={sideLength}
          />
        );
      })}
    </InlineFlex>
  </div>
);
RatingStars.propTypes = {
  averageRating: PropTypes.number,
  sideLength: PropTypes.string,
  starColor: PropTypes.string,
};

export default RatingStars;
